export default {
  global: {
    list: {
      title: "List of {name}",
    },
    view: {
      title: "Data for {name}",
    },
    add: {
      title: ({ plural, named }) => plural([`Add a ${named("name")}`, `Add a ${named("name")}`]),
      success: ({ plural, named }) =>
        plural([`${named("name")} added successfully!`, `${named("name")} added successfully!`]),
    },
    accept: {
      title: ({ plural, named }) => plural([`Accept a ${named("name")}`, `Accept a ${named("name")}`]),
      success: ({ plural, named }) =>
        plural([`${named("name")} accepted successfully !`, `${named("name")} accepted successfully !`]),
    },
    decline: {
      title: ({ plural, named }) => plural([`Decline a ${named("name")}`, `Decline a ${named("name")}`]),
      success: ({ plural, named }) =>
        plural([`${named("name")} declined successfully !`, `${named("name")} declined successfully !`]),
    },
    edit: {
      title: ({ plural, named }) =>
        plural([`Edit ${named("name")}`, `Edit a ${named("name")}`, `Edit a ${named("name")}`]),
      success: ({ plural, named }) =>
        plural([`${named("name")} edited successfully!`, `${named("name")} edited successfully!`]),
    },
    unactive: {
      title: ({ plural, named }) =>
        plural([
          `Desactivate the ${named("name")}`,
          `Desactivate a ${named("name")}`,
          `Desactivate an ${named("name")}`,
        ]),
      sub_title: ({ plural, named }) =>
        plural([
          `Are you sure you want to desactivate this ${named("name")}`,
          `Are you sure you want to desactivate this ${named("name")}`,
          `Are you sure you want to desactivate ${named("name")}`,
        ]),
      success: ({ plural, named }) =>
        plural([`${named("name")} successfully desactivate!`, `${named("name")} successfully desactivate!`]),
    },
    regenerate: {
      errors: "Error during regeneration",
      title: ({ plural, named }) => plural([`Regenerate a ${named("name")}`, `Regenerate a ${named("name")}`]),
      success: ({ plural, named }) =>
        plural([`${named("name")} successfully regenerated !`, `${named("name")} successfully regenerated !`]),
    },
    active: {
      title: ({ plural, named }) =>
        plural([`Activate ${named("name")}`, `Activate a ${named("name")}`, `Activate a ${named("name")}`]),
      sub_title: ({ plural, named }) =>
        plural([
          `Are you sure you want to activate this ${named("name")}?`,
          `Are you sure you want to activate this ${named("name")}?`,
          `Are you sure you want to activate ${named("name")}?`,
        ]),
      success: ({ plural, named }) =>
        plural([`${named("name")} activated successfully !`, `${named("name")} activated successfully !`]),
    },
    import: {
      errors: "Your file contains errors. Please correct them and restart the import.",
      title: "Import {name}",
      error: "Error in line {line} / column {column}:",
      success: ({ plural, named }) =>
        plural([`${named("name")} imported successfully!`, `${named("name")} imported successfully!`]),
    },
    ypareo: {
      title: "Last synchronization on: {date}",
      title_failure: "Synchronization failed. Last attempt made on: {date}",
    },
    export: {
      title: "Export {name}",
      title_singular: "Export {name}",
      title_alone: "Export",
      success: ({ plural, named }) =>
        plural([`${named("name")} exported successfully!`, `${named("name")} exported successfully!`]),
    },
    update: {
      title: "Complete your {name}",
      success: "{name} completed successfully",
    },
    search: {
      title: "Search for {name}",
      reset_filters: "Reset filters",
    },
    sort: {
      success: "Order of {name} updated successfully!",
    },
    download: {
      success: "{name} downloaded successfully!",
      title: "Download {name}",
      done: "Download completed",
      error: "An error occurred while downloading",
    },
    move: {
      success: ({ plural, named }) =>
        plural([`${named("name")} moved successfully!`, `${named("name")} moved successfully!`]),
    },
    copy: {
      success: ({ plural, named }) =>
        plural([`${named("name")} duplicated successfully!`, `${named("name")} duplicated successfully!`]),
      title: ({ plural, named }) => plural([`Duplicate this ${named("name")}`, `Duplicate this ${named("name")}`]),
      sub_title: ({ plural, named }) =>
        plural([
          `Are you sure you want to duplicate this ${named("name")}?`,
          `Are you sure you want to duplicate this ${named("name")}?`,
        ]),
    },
    empty: {
      title: ({ plural, named }) =>
        plural([
          `There is no ${named("name1")} in this ${named("name2")}, please click ‘+’ to add one`,
          `There is no ${named("name1")} in this ${named("name2")}, please click ‘+’ to add one`,
          `No ${named("name1")} found in this ${named("name2")}, please click ‘+’ to add one`,
        ]),
      dashboard: "No {name} found",
      no_data_available: "No data available",
    },
    delete: {
      title_alone: "Delete",
      title: ({ plural, named }) =>
        plural([`Delete ${named("name")}`, `Delete a ${named("name")}`, `Delete a ${named("name")}`]),
      sub_title: ({ plural, named }) =>
        plural([
          `Are you sure you want to delete a ${named("name")}?`,
          `Are you sure you want to delete a ${named("name")}?`,
          `Are you sure you want to delete ${named("name")}?`,
        ]),
      success: ({ plural, named }) =>
        plural([
          `${named("name")} deleted successfully!`,
          `${named("name")} deleted successfully!`,
          `${named("name")} deleted successfully!`,
          `${named("name")} deleted successfully!`,
        ]),
    },
    valid: {
      title: ({ plural, named }) =>
        plural([`Valid the ${named("name")}`, `Valid the ${named("name")}`, `Valid the ${named("name")}`]),
    },
    unvalid: {
      title: ({ plural, named }) =>
        plural([`Unvalid the ${named("name")}`, `Unvalid the ${named("name")}`, `Unvalid the ${named("name")}`]),
    },
    opened: {
      title: ({ gender }) => gender(["Open", "Open", "Open", "Open"]),
    },
    closed: {
      title: ({ gender }) => gender(["Closed", "Closed", "Closed", "Closed"]),
    },

    label: {
      name: "Surname",
      date: "Date",
      triads: "Three-party groups",
      trainings: "Trainings",
    },
    actions: {
      title: "Actions",
      empty: "No action currently available",
    },
    see_more: "See more...",
    see_less: "See less...",
    hide_detail: "Hide details",
    see_detail: "Display/ details",
    collapse_show: "Show",
    collapse_reduce: "Collapse",
    close: "Close",
    duration: "Durée",
    period: "Période",
    show_hide_actions: "Display/Hide actions",
    visible: "Visible",
    visible_by: "Visible to",
    hidden: "Hidden",
    send: "Send",
    send_mail: "Send an email",
    send_opco: "Submit to OPCO",
    valid_file: "Validate the file",
    language: {
      change: "Change language ({language})",
      french: "French",
      english: "English",
      spanish: "Spanish",
      german: "German",
    },
    stats: "Statistics",
    setting: "Settings",
    module: "Modules",
    control: "Control",
    light: "light ",
    dark: "Dark",
    caption: {
      title: "Legend",
    },
    home_alert: {
      title: "Information",
      do_not_show_agin: "Do not display this alert again",
    },
    entity: {
      contact: {
        title: ({ plural }) => plural(["Contact", "Contacts"]),
      },
    },
    menu: {
      studea_manager_area: "Traininig course managment",
      admin_area: "Admin dashboard",
    },
    total: "Total",
    totalCompany: "Total employer's share (mandatory contribution + remaining charge)",
    table: {
      filtered_result: ({ plural }) => plural(["filtered result", "filtered results"]),
    },
    user: {
      activate: {
        success: "User successfully activated!",
      },
    },
    other: ({ plural }) => plural(["Other", "Others"]),
    data_table: {
      filtered_result: ({ plural, named }) =>
        plural([`(${named("count")} filtered result)`, `(${named("count")} filtered results)`]),
      filter_active: "(filter active)",
      select_all: "Select all",
      select_line: "Select row",
      year: ({ named }) => `Year ${named("year")}`,
    },
    errors: "Regeneration error",
    show_hide_caption: "Show / Hide legend",
    title: "Legend",
    success: "User successfully activated!",
    expand: "Expand",
    collapse: "Collapse",
    drag_to_reorder: "Drag to reorder",
    comments: "Comments",
    support: "Access STUDEA Support",
    new_window: "(opens in new window)",
    historic: {
      title: "History",
    },
    aria_label_separator: " — ",
  },
  breadcrumb: {
    home: "Home",
  },
  loading: "Loading",
};
